webpackJsonp([115633355296414],{

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _PatternConstruction = __webpack_require__(22);
	
	var _PatternConstruction2 = _interopRequireDefault(_PatternConstruction);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _FormsPatternTutorialBranch = __webpack_require__(41);
	
	var _FormsPatternTutorialBranch2 = _interopRequireDefault(_FormsPatternTutorialBranch);
	
	var _createTweetDialog = __webpack_require__(52);
	
	var _createTweetDialog2 = _interopRequireDefault(_createTweetDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _PatternConstruction2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      '1. Refactor Fields'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step we\'ll make small change to refactor our fields, and eliminate the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'onBlur'
	      ),
	      ' callback from our forms.'
	    ),
	    _react2.default.createElement(_FormsPatternTutorialBranch2.default, { branch: 'create.1' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'What\'s the problem?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Take a look at the code below, which reflects the field to capture text input:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      <div className={`form-group ${touched[\'text\'] && errors[\'text\'] ? \'has-error\' : \'\'}`}>\n        <label>\n          Message\n        </label>\n        <textarea\n          className="form-control"\n          rows="3"\n          value={data.text}\n          placeholder="What\'s happening?"\n          onChange={(event) => {\n            this.onChange(\'text\', event.target.value)\n          }}\n          onBlur={() => {\n            this.onBlur(\'text\');\n          }}\n        />\n        {touched[\'text\'] && errors[\'text\'] ? (\n          <span className="help-block">\n            {errors[\'text\']}\n          </span>\n        ) : null}\n      </div>\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'One concern with this code is the number of places where the name of the field appears, which is ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'text'
	      ),
	      ' in this example. For example:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'touched[\'text\'] && errors[\'text\']'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'data.text'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'this.onChange(\'text\', event.target.value)'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'this.onBlur(\'text\')'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'touched[\'text\'] && errors[\'text\']'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'errors[\'text\']'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this case, there are 8 places where ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'text'
	      ),
	      ' appears, and it\'s not hard to picture a scenario where a bug is accidentally introduced just by mistyping the name, or forgetting to add or update one of those locations.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'How do we solve it?'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this step, we\'re going to solve that by introducing a component called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Field'
	      ),
	      ' that is part of the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-react-forms'
	      ),
	      ' package. After introducing this component, we\'ll only need to specify the name of the field ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'once'
	      ),
	      ', and reduce the risk of copy/paste errors.'
	    ),
	    _react2.default.createElement(
	      'blockquote',
	      null,
	      _react2.default.createElement(
	        'p',
	        null,
	        'You can learn more about the ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'Field'
	        ),
	        ' component ',
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/forms/components/field/' },
	          'here'
	        ),
	        '.'
	      )
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Import Field'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Start by importing ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Field'
	      ),
	      ' from ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-react-forms'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/dialogs/tweet/create/index.js\n      import { Field } from \'lore-react-forms\';\n      ...\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Then refactor the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'text'
	      ),
	      ' field to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/dialogs/tweet/create/index.js\n      <div className="row">\n        <div className="col-md-12">\n          <Field name="text" data={data} errors={errors} onChange={this.onChange}>\n            {(field) => {\n              return (\n                <div className={`form-group ${field.touched && field.error ? \'has-error\' : \'\'}`}>\n                  <label>\n                    Message\n                  </label>\n                  <textarea\n                    className="form-control"\n                    rows="3"\n                    value={field.value}\n                    placeholder="What\'s happening?"\n                    onChange={(event) => {\n                      field.onChange(event, event.target.value)\n                    }}\n                    onBlur={field.onBlur}\n                  />\n                  {field.touched && field.error ? (\n                    <span className="help-block">\n                      {field.error}\n                    </span>\n                  ) : null}\n                </div>\n              );\n            }}\n          </Field>\n        </div>\n      </div>\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'And then refactor the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'userId'
	      ),
	      ' field to look like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      // src/dialogs/tweet/create/index.js\n      <div className="row">\n        <div className="col-md-12">\n          <Field name="userId" data={data} errors={errors} onChange={this.onChange}>\n            {(field) => {\n              return (\n                <div className={`form-group ${field.touched && field.error ? \'has-error\' : \'\'}`}>\n                  <label>\n                    User\n                  </label>\n                  <Connect callback={(getState, props) => {\n                    return {\n                      options: getState(\'user.find\')\n                    };\n                  }}>\n                    {(connect) => {\n                      return (\n                        <select\n                          className="form-control"\n                          value={field.value}\n                          onChange={(event) => {\n                            const value = event.target.value;\n                            field.onBlur();\n                            field.onChange(event, value ? Number(value) : undefined)\n                          }}\n                        >\n                          {[<option key="" value=""/>].concat(connect.options.data.map((datum) => {\n                            return (\n                              <option key={datum.id} value={datum.id}>\n                                {datum.data.nickname}\n                              </option>\n                            );\n                          }))}\n                        </select>\n                      )\n                    }}\n                  </Connect>\n                  {field.touched && field.error ? (\n                    <span className="help-block">\n                      {field.error}\n                    </span>\n                  ) : null}\n                </div>\n              );\n            }}\n          </Field>\n        </div>\n      </div>\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Review'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This wasn\'t a big change, but it does provide a few benefits.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'For starters, we no longer need to use the name of the field to access things like the value of the field, which simplifies some of the code:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'code',
	          null,
	          'touched[\'text\'] && errors[\'text\']'
	        ),
	        ' becomes ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'field.touched && field.error'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'code',
	          null,
	          'data.text'
	        ),
	        ' becomes ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'field.value'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'code',
	          null,
	          'this.onChange(\'text\', event.target.value)'
	        ),
	        ' becomes ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'field.onChange(event, event.target.value)'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'code',
	          null,
	          'this.onBlur(\'text\')'
	        ),
	        ' becomes ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'field.onBlur'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          'code',
	          null,
	          'errors[\'text\']'
	        ),
	        ' becomes ',
	        _react2.default.createElement(
	          'code',
	          null,
	          'field.error'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Additionally, the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Field'
	      ),
	      ' is now keeping track of whether the component has been touched or not, which means we no longer need to keep track of ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'touched'
	      ),
	      ' in the forms state, and can also delete the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'onBlur()'
	      ),
	      ' callback.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'So now, instead of referencing the name of the field, we only need to tell the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Field'
	      ),
	      ' what it\'s called, and the component will automatically map ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'data'
	      ),
	      ' into ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'value'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'errors'
	      ),
	      ' into ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'error'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Visual Check-in'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'If everything went well, clicking the create button will still launch a dialog that you can use to create a new tweet.'
	    ),
	    _react2.default.createElement('img', { className: 'drop-shadow', src: _createTweetDialog2.default }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Code Changes'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Below is a list of files modified during this step.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'src/dialogs/tweet/create/index.js'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      import React from \'react\';\n      import createReactClass from \'create-react-class\';\n      import PropTypes from \'prop-types\';\n      import _ from \'lodash\';\n      import { Connect } from \'lore-hook-connect\';\n      import { Field } from \'lore-react-forms\';\n\n      export default createReactClass({\n        displayName: \'CreateTweetDialog\',\n\n        propTypes: {\n          onCancel: PropTypes.func\n        },\n\n        getInitialState() {\n          return {\n            data: {\n              text: \'\',\n              userId: undefined\n            }\n          };\n        },\n\n        request(data) {\n          lore.actions.tweet.create(data);\n        },\n\n        onSubmit() {\n          const { data } = this.state;\n          this.request(data);\n          this.dismiss();\n        },\n\n        dismiss() {\n          this.props.onCancel();\n        },\n\n        onChange(name, value) {\n          const nextData = _.merge({}, this.state.data);\n          nextData[name] = value;\n          this.setState({\n            data: nextData\n          });\n        },\n\n        getValidators: function(data) {\n          return {\n            text: [function(value) {\n              if (!value) {\n                return \'This field is required\';\n              }\n            }],\n            userId: [function(value) {\n              if (value === undefined) {\n                return \'This field is required\'\n              }\n            }]\n          };\n        },\n\n        getErrors: function(validatorDictionary, data) {\n          return _.mapValues(data, function(value, key) {\n            const validators = validatorDictionary[key];\n            let error = null;\n            if (validators) {\n              validators.forEach(function(validator) {\n                error = error || validator(value);\n              });\n            }\n            return error;\n          });\n        },\n\n        hasError: function(errors) {\n          const errorCount = _.reduce(errors, function(result, value, key) {\n            if (value) {\n              return result + 1;\n            }\n\n            return result;\n          }, 0);\n\n          return errorCount > 0;\n        },\n\n        render() {\n          const { data } = this.state;\n          const validators = this.getValidators(data);\n          const errors = this.getErrors(validators, data);\n          const hasError = this.hasError(errors);\n\n          return (\n            <div className="modal-dialog">\n              <div className="modal-content">\n                <div className="modal-header">\n                  <button type="button" className="close" onClick={this.dismiss}>\n                    <span>&times;</span>\n                  </button>\n                  <h4 className="modal-title">\n                    Create Tweet\n                  </h4>\n                </div>\n                <div className="modal-body">\n                  <div className="row">\n                    <div className="col-md-12">\n                      <Field name="text" data={data} errors={errors} onChange={this.onChange}>\n                        {(field) => {\n                          return (\n                            <div className={`form-group ${field.touched && field.error ? \'has-error\' : \'\'}`}>\n                              <label>\n                                Message\n                              </label>\n                              <textarea\n                                className="form-control"\n                                rows="3"\n                                value={field.value}\n                                placeholder="What\'s happening?"\n                                onChange={(event) => {\n                                  field.onChange(event, event.target.value)\n                                }}\n                                onBlur={field.onBlur}\n                              />\n                              {field.touched && field.error ? (\n                                <span className="help-block">\n                                  {field.error}\n                                </span>\n                              ) : null}\n                            </div>\n                          );\n                        }}\n                      </Field>\n                    </div>\n                  </div>\n                  <div className="row">\n                    <div className="col-md-12">\n                      <Field name="userId" data={data} errors={errors} onChange={this.onChange}>\n                        {(field) => {\n                          return (\n                            <div className={`form-group ${field.touched && field.error ? \'has-error\' : \'\'}`}>\n                              <label>\n                                User\n                              </label>\n                              <Connect callback={(getState, props) => {\n                                return {\n                                  options: getState(\'user.find\')\n                                };\n                              }}>\n                                {(connect) => {\n                                  return (\n                                    <select\n                                      className="form-control"\n                                      value={field.value}\n                                      onChange={(event) => {\n                                        const value = event.target.value;\n                                        field.onBlur();\n                                        field.onChange(event, value ? Number(value) : undefined)\n                                      }}\n                                    >\n                                      {[<option key="" value=""/>].concat(connect.options.data.map((datum) => {\n                                        return (\n                                          <option key={datum.id} value={datum.id}>\n                                            {datum.data.nickname}\n                                          </option>\n                                        );\n                                      }))}\n                                    </select>\n                                  )\n                                }}\n                              </Connect>\n                              {field.touched && field.error ? (\n                                <span className="help-block">\n                                  {field.error}\n                                </span>\n                              ) : null}\n                            </div>\n                          );\n                        }}\n                      </Field>\n                    </div>\n                  </div>\n                </div>\n                <div className="modal-footer">\n                  <div className="row">\n                    <div className="col-md-12">\n                      <button\n                        type="button"\n                        className="btn btn-default"\n                        onClick={this.dismiss}\n                      >\n                        Cancel\n                      </button>\n                      <button\n                        type="button"\n                        className="btn btn-primary"\n                        disabled={hasError}\n                        onClick={this.onSubmit}\n                      >\n                        Create\n                      </button>\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>\n          );\n        }\n\n      });\n      ' }),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Next Steps'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Next we\'re going to ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '../step-2/' },
	        'refactor the form'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-forms-pattern-create-step-1-js-705ba881013666edacaf.js